import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEdit } from 'react-icons/fa';
import Notification from '../shared/Notification';
import styles from './verify.module.css';
import NavHeader from './NavHeader';
import Footer from '../shared/Footer';

const Verify = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const storedEmailOrPhone = sessionStorage.getItem('verifyEmailOrPhone') || '';
    const [originalEmailOrPhone, setOriginalEmailOrPhone] = useState(storedEmailOrPhone);
    const [formData, setFormData] = useState({ emailOrPhone: storedEmailOrPhone, verificationCode: '' });

    const [isVerifyDisabled, setIsVerifyDisabled] = useState(false);
    const [notification, setNotification] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'emailOrPhone' && e.target.value !== originalEmailOrPhone) {
            setIsVerifyDisabled(true);
        }
    };

    const handleEditClick = () => {
        setIsEditing(true);
        setIsVerifyDisabled(true);
    };

    const handleBlur = () => {
        setIsEditing(false);
        if (formData.emailOrPhone === originalEmailOrPhone) {
            setIsVerifyDisabled(false);
        }
        handleResend();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authApplicant/verify', formData);
            const { token } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('notification', 'Signup successful!');
            sessionStorage.removeItem('verifyEmailOrPhone');
            navigate('/');
        } catch (error) {
            setNotification(error.response.data.message);
        }
    };

    const handleResend = async () => {
        setNotification('Resending verification code...');
        setIsVerifyDisabled(false);
        try {
            const payload = {
                emailOrPhone: originalEmailOrPhone,
                newEmailOrPhone: formData.emailOrPhone
            };
            setOriginalEmailOrPhone(formData.emailOrPhone);
            sessionStorage.setItem('verifyEmailOrPhone', formData.emailOrPhone);
            const response = await axios.post('/api/authApplicant/resend-verification', payload);
            if (response.data.success) {
                setNotification('Verification code sent.');
            }
        } catch (error) {
            // silent
        }
    };

    return (
        <>
        <NavHeader />
        {notification && (
            <Notification message={notification} onClose={() => setNotification('')} />
        )}

        <div className={styles.verifyPage}>
            <div className={styles.card}>

                <div className={styles.cardHeader}>
                    <h1 className={styles.headline}>Check your inbox 📬</h1>
                    <p className={styles.subtext}>Enter the 6-digit code we sent you to your email.</p>
                </div>

                <div className={styles.cardBody}>

                    {/* Destination row */}
                    <div className={styles.destinationRow}>
                        <span className={styles.destinationLabel}>Sent to:</span>
                        {isEditing ? (
                            <input
                                className={styles.editingInput}
                                type="text"
                                name="emailOrPhone"
                                value={formData.emailOrPhone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoFocus
                            />
                        ) : (
                            <>
                                <span className={styles.destinationValue}>{formData.emailOrPhone}</span>
                                <button type="button" className={styles.editBtn} onClick={handleEditClick} title="Edit">
                                    <FaEdit size={14} />
                                </button>
                            </>
                        )}
                    </div>

                    <form onSubmit={handleSubmit} noValidate className={styles.verifyForm}>

                        <div className={styles.fieldWrap}>
                            <span className={styles.fieldIcon}>🔢</span>
                            <input
                                className={styles.input}
                                type="text"
                                name="verificationCode"
                                placeholder="6-digit code"
                                value={formData.verificationCode}
                                onChange={handleChange}
                                maxLength={6}
                                required
                            />
                        </div>

                        {error && <div className={styles.errorMsg}>{error}</div>}

                        <button type="submit" className={styles.verifyBtn} disabled={isVerifyDisabled}>
                            Verify & continue →
                        </button>

                        <button type="button" className={styles.resendBtn} onClick={handleResend}>
                            Resend code
                        </button>

                    </form>
                </div>

            </div>
        </div>
        <Footer/>
        </>
    );
};

export default Verify;